import { render, staticRenderFns } from "./interpretationAddenumViewer.vue?vue&type=template&id=95b3c630&"
import script from "./interpretationAddenumViewer.vue?vue&type=script&lang=js&"
export * from "./interpretationAddenumViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports